import { useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import Select from 'react-select';
import { scrollToTop } from "../utils/helper.js";
import { ddStyles } from "../utils/CommonStyles.js";
import UserAnalyticsTable from "./UserAnalyticsTable";
import UserAppSurveyTable from "./UserAppSurveyTable";
import UserDepartmentTable from "./UserDepartmentTable";
import UserProductTable from "./UserProductTable";
import UserLocationTable from "./UserLocationTable";
import UserProvisioningTable from "./UserProvisioningTable";
import UserPartnerTable from "./UserPartnerTable";
import UserSubsidiaryTable from "./UserSubsidiaryTable";
import UserDelegateTable from "./UserDelegateTable";
import PartnerAppSurveyTable from "./PartnerAppSurveyTable";
import PartnerDepartmentTable from "./PartnerDepartmentTable";
import PartnerLocationTable from "./PartnerLocationTable";
import PartnerProductTable from "./PartnerProductTable";
import SubsidiaryAppSurveyTable from "./SubsidiaryAppSurveyTable";
import SubsidiaryDepartmentTable from './SubsidiaryDepartmentTable';
import SubsidiaryLocationTable from './SubsidiaryLocationTable';
import SubsidiaryProductTable from './SubsidiaryProductTable';
import UserAppSurveyAlertTable from "./UserAppSurveyAlertTable";
import PartnerSurveyAlertTable from "./PartnerSurveyAlertTable";
import UserDelegateAppSurveyTable from "./UserDelegateAppSurveyTable";
import UserDelegateLocationTable from './UserDelegateLocationTable';
import UserDelegateProductTable from './UserDelegateProductTable';
import UserContext from "../contexts/UserContext";

function UserDetailsModal({ key, t, user, setDetails }) {
	let menuOptions = [{ label: t("page.option.mycompany"), value: "MyCompany" },
	{ label: t("page.supplier"), value: "Supplier" },
	{ label: t("page.subsidiary"), value: "Subsidiary" },
	{ label: t("header.admin.delegate"), value: "Delegate" },];


	const [isSubmit, setIsSubmit] = useState(false);
	const [appSurvey, setAppSurvey] = useState(false);
	const [menuSelected, setMenuSelected] = useState({ name: "menuOption", label: "", value: "" });
	const [submenuSelected, setSubmenuSelected] = useState({ name: "submenuOption", label: "", value: "" });
	const [error, setError] = useState("");
	const [submenuOptions, setSubmenuOptions] = useState([{}]);
	const [partner, setPartner] = useState(false);
	const [subsidiary, setSubsidiary] = useState(false);
	const [delegate, setDelegate] = useState(false);

	const [department, setDepartment] = useState(false);
	const [location, setLocation] = useState(false);
	const [product, setProduct] = useState(false);
	const [analytics, setAnalytics] = useState(false);
	const [appSurveyAlert, setAppSurveyAlert] = useState(false);
	const [provisioning, setProvisioning] = useState(false);
	const [partnerAppSurvey, setPartnerAppSurvey] = useState(false);
	const [partnerDepartment, setPartnerDepartment] = useState(false);
	const [partnerLocation, setPartnerLocation] = useState(false);
	const [partnerProduct, setPartnerProduct] = useState(false);
	const [partnerSurveyAlert, setPartnerSurveyAlert] = useState(false);
	const [subsidiaryAppSurvey, setSubsidiaryAppSurvey] = useState(false);
	const [subsidiaryDepartment, setSubsidiaryDepartment] = useState(false);
	const [subsidiaryLocation, setSubsidiaryLocation] = useState(false);
	const [subsidiaryProduct, setSubsidiaryProduct] = useState(false);
	const [delegateAppSurvey, setDelegateAppSurvey] = useState(false);
	const [delegateLocation, setDelegateLocation] = useState(false);
	const [delegateProduct, setDelegateProduct] = useState(false);
	const [userPartnerList, setUserPartnerList] = useState([]);
	const [supplierId, setSupplierId] = useState(0);
	const userCtx = useContext(UserContext);

	useEffect(() => {
		scrollToTop();
	}, []);

	const closeText = t("page.close");
	const initialValues = {
		userId: "",
		userName: "",
		password: "",
		email: "",
		address1: "",
		address2: "",
		phone: "",
		zipCode: "",
		zipExt: "",
		city: "",
		stateKey: 0,
		interestKey: 0,
		roleKey: 0,
		role: "",
		appAccess: [],
		stateCode: "",
		stateName: "",
		countryCode: "US",
		countryName: "United States of America",
		userTimeZone: "America/Los_Angeles",
		userLanguage: "en",
		updatedById: "",
		companyId: 0,
		companyName: "",
		companyCity: "",
		companyStateCode: "",
		companyCountryCode: "",
		userType: "CORP",
		userSubType: "Employee",
	};
	const [editFormData, setEditFormData] = useState(initialValues);

	const menuOptionHandler = (selectedOption, action) => {
		let menuOption = selectedOption ? selectedOption.value : "";
		let submenus = [];
		if (selectedOption) {
			setMenuSelected(selectedOption);
		} else {
			setMenuSelected({ name: "menuOption", label: "", value: "" });
		}

		if (menuOption === "MyCompany") {
			submenus.push({ label: t("page.analytics"), value: "Analytics" });
			submenus.push({ label: t("page.provisioning"), value: "Provision" })
		}
		submenus.push({ label: t("page.appSurvey"), value: "Survey" });
		if ((menuOption === "MyCompany") || (menuOption === "Supplier")) {
			submenus.push({ label: t("page.survey.alert"), value: "SurveyAlert" });
		}
		if ((menuOption === "MyCompany") || (menuOption === "Supplier") || (menuOption === "Subsidiary")) {
			submenus.push({ label: t("page.dept"), value: "Dept" });
		}
		submenus.push({ label: t("page.loc"), value: "Location" });
		submenus.push({ label: t("page.prod"), value: "Product" });
		setSubmenuOptions(submenus);
		handleMenuSelect(menuOption);
	}

	const handleMenuSelect = (menuOption) => {
		switch (menuOption) {
			case "MyCompany": handleCompanySelect();
				break;
			case "Supplier": handlePartnerSelect(user);
				break;
			case "Subsidiary": handleSubsidiarySelect(user);
				break;
			case "Delegate": handleDelegateSelect(user);
				break;
			default: break;
		}
	};

	const resetAllSelections = () => {
		setAnalytics(false);
		setDepartment(false);
		setLocation(false);
		setProduct(false);
		setAppSurvey(false);
		setAppSurveyAlert(false);
		setProvisioning(false);
		setPartner(false);
		setSubsidiary(false);
		setPartnerAppSurvey(false);
		setPartnerDepartment(false);
		setPartnerLocation(false);
		setPartnerProduct(false);
		setSubsidiaryAppSurvey(false);
		setSubsidiaryDepartment(false);
		setSubsidiaryLocation(false);
		setSubsidiaryProduct(false);
		setPartnerSurveyAlert(false);
		setDelegate(false);
		setDelegateAppSurvey(false);
		setDelegateLocation(false);
		setDelegateProduct(false);
	}
	const handleCompanySelect = () => {
		setSubmenuSelected({ name: "submenuOption", label: "", value: "" });
		setError("");
		resetAllSelections();
	};
	const handlePartnerSelect = (user) => {
		setSubmenuSelected({ name: "submenuOption", label: "", value: "" });
		setError("");
		resetAllSelections();
		setPartner(true);

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
		
	};
	const handleSubsidiarySelect = (user) => {
		setSubmenuSelected({ name: "submenuOption", label: "", value: "" });
		setError("");
		resetAllSelections();
		setSubsidiary(true);
		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
	};
	const handleDelegateSelect = (user) => {
		setSubmenuSelected({ name: "submenuOption", label: "", value: "" });
		setError("");
		resetAllSelections();
		setDelegate(true);
		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
	};
	const submenuOptionHandler = (selectedOption) => {
		let submenuOption = selectedOption ? selectedOption.value : "";
		if (selectedOption) {
			setSubmenuSelected(selectedOption);
		} else {
			setSubmenuSelected({ name: "submenuOption", label: "", value: "" })
		}
		switch (submenuOption) {
			case "Analytics": handleAnalyticsClick(user);
				break;
			case "Survey": handleAppSurveyClick(user);
				break;
			case "Dept": handleDepartmentClick(user);
				break;
			case "Location": handleLocationClick(user);
				break;
			case "Product": handleProductClick(user);
				break;
			case "SurveyAlert": handleSurveyAlertClick(user);
				break;
			case "Provision": handleProvisioningClick(user);
				break;
			default: handleSubMenuClear();
				break;
		}

	}

	const handleSubMenuClear = () => {
		let menuOption = menuSelected.value ? menuSelected.value : "";
		setError("");
		handleMenuSelect(menuOption);
	};

	const handleAnalyticsClick = (user) => {
		setError("");
		resetAllSelections();
		setAnalytics(true);

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
	};
	const handleProvisioningClick = (user) => {
		setError("");
		resetAllSelections();
		setProvisioning(true);

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
	};
	const handleAppSurveyClick = (user) => {
		setError("");
		resetAllSelections();
		if (menuSelected.value == "Supplier") {
			setPartnerAppSurvey(true);
			setAppSurvey(false);
			setSubsidiaryAppSurvey(false);
			setDelegateAppSurvey(false);
		} else if (menuSelected.value == "Subsidiary") {
			setSubsidiaryAppSurvey(true);
			setPartnerAppSurvey(false);
			setAppSurvey(false);
			setDelegateAppSurvey(false);
		} else if (menuSelected.value == "Delegate"){
			setDelegateAppSurvey(true);
			setAppSurvey(false);
			setPartnerAppSurvey(false);
			setSubsidiaryAppSurvey(false);
		} else {
			setAppSurvey(true);
			setPartnerAppSurvey(false);
			setSubsidiaryAppSurvey(false);
			setDelegateAppSurvey(false);
		}

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
	};

	const handleSurveyAlertClick = (user) => {
		setError("");
		resetAllSelections();
		if (menuSelected.value == "MyCompany") {
			setAppSurveyAlert(true);
			setPartnerSurveyAlert(false);
		} else if (menuSelected.value == "Supplier") {
			setAppSurveyAlert(false);
			setPartnerSurveyAlert(true);
		}

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });
	};

	const handleDepartmentClick = (user) => {
		setError("");
		resetAllSelections();
		if (menuSelected.value == "Supplier") {
			setPartnerDepartment(true);
			setDepartment(false);
			setSubsidiaryDepartment(false);
		} else if (menuSelected.value == "Subsidiary") {
			setSubsidiaryDepartment(true);
			setPartnerDepartment(false);
			setDepartment(false);
		} else {
			setDepartment(true);
			setPartnerDepartment(false);
			setSubsidiaryDepartment(false);
		}
		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });

	};
	const handleLocationClick = (user) => {
		setError("");
		resetAllSelections();
		if (menuSelected.value == "Supplier") {
			setPartnerLocation(true);
			setLocation(false);
			setSubsidiaryLocation(false);
			setDelegateLocation(false);
		} else if (menuSelected.value == "Subsidiary") {
			setSubsidiaryLocation(true);
			setPartnerLocation(false);
			setLocation(false);
			setDelegateLocation(false);
		} else if (menuSelected.value == "Delegate") {
			setDelegateLocation(true);
			setSubsidiaryLocation(false);
			setPartnerLocation(false);
			setLocation(false);
		} else {
			setLocation(true);
			setPartnerLocation(false);
			setSubsidiaryLocation(false);
			setDelegateLocation(false);
		}

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });

	};

	const handleProductClick = (user) => {
		setError("");
		resetAllSelections();
		if (menuSelected.value == "Supplier") {
			setPartnerProduct(true);
			setProduct(false);
			setSubsidiaryProduct(false);
			setDelegateProduct(false);
		} else if (menuSelected.value == "Subsidiary") {
			setSubsidiaryProduct(true);
			setPartnerProduct(false);
			setProduct(false);
			setDelegateProduct(false);
		} else if (menuSelected.value == "Delegate") {
			setDelegateProduct(true);
			setSubsidiaryProduct(false);
			setPartnerProduct(false);
			setProduct(false);
		} else {
			setProduct(true);
			setPartnerProduct(false);
			setSubsidiaryProduct(false);
			setDelegateProduct(false);
		}

		let formData = JSON.parse(JSON.stringify(user));
		setEditFormData({ ...editFormData, ...formData });

	};
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="modalContainer">
					<div className="row">
						<div className="col mt-3">
							<div id="userId" className="header-label">
								{user.userName + " : " + user.userId}
							</div>

						</div>
					</div>
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div className="form-group">
								<label className="form-label">
									{t("page.option")}
								</label>
								<Select
									name="menuOption"
									options={menuOptions}
									onChange={menuOptionHandler}
									value={menuSelected}
									isSearchable={true}
									isClearable={true}
									className="myselect"
									inputId="menu-input"
									styles={ddStyles}
								/>
							</div>
						</div>
						<div className="col">
							<div className="form-group">
								<label className="form-label">
									{t("page.subOption")}
								</label>
								<Select
									name="submenuOption"
									options={submenuOptions}
									onChange={submenuOptionHandler}
									value={submenuSelected}
									isSearchable={true}
									isClearable={true}
									className="myselect"
									inputId="submenu-input"
									styles={ddStyles}
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>

					{analytics &&
						<UserAnalyticsTable key={key} setAnalytics={setAnalytics} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{appSurvey &&
						<UserAppSurveyTable key={key} setAppSurvey={setAppSurvey} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{appSurveyAlert &&
						<UserAppSurveyAlertTable key={key} setAppSurveyAlert={setAppSurveyAlert} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{department &&
						<UserDepartmentTable key={key} setDepartment={setDepartment} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{product &&
						<UserProductTable key={key} setProduct={setProduct} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{location &&
						<UserLocationTable key={key} setLocation={setLocation} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{provisioning &&
						<UserProvisioningTable key={key} setProvisioning={setProvisioning} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{partner &&
						<UserPartnerTable key={key} setPartner={setPartner} loginId={editFormData.userId} companyId={editFormData.companyId} setUserPartnerList={setUserPartnerList}/>
					}
					{subsidiary &&
						<UserSubsidiaryTable key={key} setSubsidiary={setSubsidiary} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{delegate &&
						<UserDelegateTable key={key} setDelegate={setDelegate} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{partnerAppSurvey &&
						<PartnerAppSurveyTable key={key} setPartnerAppSurvey={setPartnerAppSurvey} loginId={editFormData.userId} 
						companyId={editFormData.companyId} userPartnerList={userPartnerList} setSupplierId={setSupplierId} supplierId ={supplierId} />
					}
					{partnerDepartment &&
						<PartnerDepartmentTable key={key} setPartnerDepartment={setPartnerDepartment} loginId={editFormData.userId} 
						companyId={editFormData.companyId} userPartnerList={userPartnerList} setSupplierId={setSupplierId} supplierId ={supplierId}/>
					}
					{partnerLocation &&
						<PartnerLocationTable key={key} setPartnerLocation={setPartnerLocation} loginId={editFormData.userId} 
						companyId={editFormData.companyId} userPartnerList={userPartnerList} setSupplierId={setSupplierId} supplierId ={supplierId}/>
					}
					{partnerSurveyAlert &&
						<PartnerSurveyAlertTable key={key} setPartnerSurveyAlert={setPartnerSurveyAlert} loginId={editFormData.userId} 
						companyId={editFormData.companyId} userPartnerList={userPartnerList} setSupplierId={setSupplierId} supplierId ={supplierId}/>
					}
					{partnerProduct &&
						<PartnerProductTable key={key} setPartnerProduct={setPartnerProduct} loginId={editFormData.userId} 
						companyId={editFormData.companyId} userPartnerList={userPartnerList} setSupplierId={setSupplierId} supplierId ={supplierId}/>
					}
					{subsidiaryAppSurvey &&
						<SubsidiaryAppSurveyTable key={key} setSubsidiaryAppSurvey={setSubsidiaryAppSurvey} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{subsidiaryDepartment &&
						<SubsidiaryDepartmentTable key={key} setSubsidiaryDepartment={setSubsidiaryDepartment} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{subsidiaryLocation &&
						<SubsidiaryLocationTable key={key} setSubsidiaryLocation={setSubsidiaryLocation} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{subsidiaryProduct &&
						<SubsidiaryProductTable key={key} setSubsidiaryProduct={setSubsidiaryProduct} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{delegateAppSurvey &&
						<UserDelegateAppSurveyTable key={key} setDelegateAppSurvey={setDelegateAppSurvey} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{delegateLocation &&
						<UserDelegateLocationTable key={key} setDelegateLocation={setDelegateLocation} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{delegateProduct &&
						<UserDelegateProductTable key={key} setDelegateProduct={setDelegateProduct} loginId={editFormData.userId} companyId={editFormData.companyId} />
					}
					{!(analytics || appSurvey || appSurveyAlert || department || product || location || partner || subsidiary
						|| partnerAppSurvey || partnerDepartment || partnerLocation || partnerSurveyAlert || partnerProduct
						|| subsidiaryAppSurvey || subsidiaryDepartment || subsidiaryLocation || subsidiaryProduct || provisioning
						|| delegate || delegateAppSurvey || delegateLocation || delegateProduct ) &&
						<div className="footer">
							<input
								type="button"
								name="edit-user-detail-close"
								id="edit-user-detail-close"
								className="btn btn-secondary btn-block" data-dismiss="modal"
								disabled={isSubmit}
								onClick={(e) => setDetails(false)}
								 style={{ marginTop: "10px", marginBottom: "10px" }}
								value={closeText}
							></input>
						</div>
					}
				</div>
				: null}
		</>
	);
}

export default UserDetailsModal;